<template>
        <div class="team-referral-tab container d-flex align-items-stretch h-100">
            <div class="d-flex flex-column w-100">
                <div v-if="config.teamEnabled" class="row pl-4 pr-4 mb-3">
                    <div class="col-6 col-md-3 offset-md-3 pr-1">
                        <b-button @click="currentTab = 'team';btnSfx();" size="lg" block :variant="currentTab == 'team' ? 'tab' : 'outline-tab'">
                            {{ $t('home.home_team_ref_tab_team') }}
                        </b-button>
                    </div>
                    <div class="col-6 col-md-3 pl-1">
                        <b-button @click="currentTab = 'referrals';btnSfx();" size="lg" block :variant="currentTab == 'referrals' ? 'tab' : 'outline-tab'">
                            {{ $t('home.home_team_ref_tab_referals') }}
                        </b-button>
                    </div>
                </div>
                <transition name="fade" mode="out-in">
                    <no-team-tab v-if="currentTab == 'team' && user.team == undefined" 
                        ref="noTeamTab"
                        @openInfo="openInfoPopup" 
                        @openInvitations="openInvitationPopup"
                        @openCreateRequest="openCreateRequestPopup" 
                        @openCreate="openCreatePopup"></no-team-tab>
                    
                    <in-team-tab v-if="currentTab == 'team' && user.team != undefined" 
                        @openInfo="openInfoPopup"></in-team-tab>

                    <home-referral-tab v-if="currentTab == 'referrals'" :tab="referralTab"></home-referral-tab>
                </transition>
            </div>
        
            <team-info-popup ref="infoPopup"></team-info-popup>
            <team-create-popup ref="createPopup"></team-create-popup>
            <team-create-request-popup ref="createRequestPopup"></team-create-request-popup>
            <team-invitation-popup ref="invitationPopup" @hasInvitations="setHasInvitations"></team-invitation-popup>
        </div>
</template>
<script>
import Vue from 'vue'

import InfoPopup from '../components/teams/InfoPopup.vue';
import NoTeamTab from '../components/teams/NoTeamTab.vue';
import InTeamTab from '../components/teams/InTeamTab.vue';
import CreatePopup from '../components/teams/CreatePopup.vue';
import CreateRequestPopup from '../components/teams/CreateRequestPopup.vue';
import InvitationPopup from '../components/teams/InvitationPopup.vue';


import HomeReferralTab from '../components/HomeReferralTab.vue';
import api from '../api'

const TeamReferralTab = Vue.component('team-referral-tab', {
    component: {NoTeamTab, InTeamTab, HomeReferralTab, InfoPopup, CreatePopup, CreateRequestPopup, InvitationPopup},
    props: {
        tab: String,
        referralTab: Number,
    },

    data(){
    	return {
            currentTab: 'team'
    	};
    },
    
    methods:{

        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },

        openCreateRequestPopup(){
            this.$refs.createRequestPopup.show();
        },

        openCreatePopup(){
            this.$refs.createPopup.show();
        },

        openInfoPopup(){
            this.$refs.infoPopup.show();
        },

        openInvitationPopup(data){
            this.$refs.invitationPopup.show(data);
        },

        setHasInvitations(has){
            this.$refs.noTeamTab.setHasInvitations(has);
        }
        
    },

    computed: {
        user() {
            return this.$store.state.auth.user;
        },
        config(){
            return this.$store.state.config.data;
        }
    },

    created(){
        if(this.config.teamEnabled)
            this.currentTab = this.tab;
        else
            this.currentTab = "referrals";
    },

    mounted(){
        this.$store.dispatch('sound/bg','BG_Home');
    },

    beforeDestroy(){
        document.getElementById('loader').classList.remove("show");
    },

    watch: {
        tab(){
            this.currentTab = this.tab;
        }
    }

});

export default TeamReferralTab
</script>
